// import ScrollOut
import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinup',
    targets:'.home #full-width-page-wrapper .wp-block-column:has(hr), .home #full-width-page-wrapper .wp-block-columns .wp-block-column:first-child:has(ul), .page-template-no-title h2 + .wp-block-columns .wp-block-column',
    onShown: function(el) {
     // remove the class
     el.classList.remove('animate__animated', 'animate__fadeInUp');
     // force reflow
     void el.offsetWidth;
     // re-add the animated cl
     el.classList.add('animate__animated', 'animate__fadeInUp');
     //el.animate([{ opacity: 0 }, { opacity: 1 }], 1000);
   }
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets:'.home #full-width-page-wrapper .wp-block-columns .wp-block-column:last-child:has(h2, .wp-block-buttons), .page-template-no-title .wp-block-columns .wp-block-column:last-child:has(h2):not(:has(.wp-block-image))',
    onShown: function(el) {
     // remove the class
     el.classList.remove('animate__animated', 'animate__fadeInRight');
     // force reflow
     void el.offsetWidth;
     // re-add the animated cl
     el.classList.add('animate__animated', 'animate__fadeInRight');
   }
});
// Fade Left Effect Animation on any item with the .fadeinleft class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets:'.page-template-no-title .wp-block-columns .wp-block-column:first-child:has(h2):not(:has(.wp-block-image)',
    onShown: function(el) {
     // remove the class
     el.classList.remove('animate__animated', 'animate__fadeInLeft');
     // force reflow
     void el.offsetWidth;
     // re-add the animated cl
     el.classList.add('animate__animated', 'animate__fadeInLeft');
   }
});

// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';
// import Swiper styles
//import 'swiper/css';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
    // Enable keyboard control
    keyboard: {
        enabled: true,
        onlyInViewport: false, // Allow keyboard control outside the viewport
    },
});
//
// Add event listeners for Enter key press on navigation buttons
const prevButton = document.querySelector('.swiper-button-prev');
const nextButton = document.querySelector('.swiper-button-next');

if (prevButton) {
    prevButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
        swiper.slidePrev();
    }
    });
}
if (nextButton) {
    nextButton.addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
        swiper.slideNext();
    }
    });
}
//
const swiperSectors = new Swiper('.swiper-sectors', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
    spaceBetween:48,
    initialSlide: 1,
    breakpoints: {
        576:{
            slidesPerView: 1,
            spaceBetween:128,
        },
        782:{
			slidesPerView: 2,
            spaceBetween:72,
		},
        1200:{
			slidesPerView: 2.25,
            spaceBetween:96,
		},
		1400:{
			slidesPerView: 2.5,
            spaceBetween:128,
		}
	},
	autoHeight: true, // Make slides equal height
	// Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
//
const swiperAccreditationLogos = new Swiper('.swiper-accreditation-logos', {
    // Optional parameters
    //direction: 'vertical',
	modules: [Autoplay, Navigation],
    loop: true,
	slidesPerView: 1,
    breakpoints: {
        782:{
			slidesPerView: 2,
            spaceBetween:80,
		},
        992:{
			slidesPerView: 4,
            spaceBetween:48,
		},
        1200:{
			slidesPerView: 5,
            spaceBetween:48,
		},
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
    // Navigation arrows
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});
//
jQuery(document).ready(function($) {
	$(window).scroll(function(){
      	scroll = $(window).scrollTop();
        //
  		if (scroll > 0) 
			$('.navbar').addClass('bg-white');
  		else 
            $('.navbar').removeClass('bg-white');
	});
    //
    // Back to Top Button
    // Get the button
    var mybutton = document.getElementById("btn-back-to-top");
    // When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
        scrollFunction();
    };
    //
    function scrollFunction() {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            mybutton.style.display = "block";
        }
        else {
            mybutton.style.display = "none";
        }
    }
    // When the user clicks on the button, scroll to the top of the document
    mybutton.addEventListener("click", backToTop);
    //
    function backToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }
    //
    function addStrongTagToLastWord(inputString) {
        const trimmedString = inputString.trim();
        const wordsArray = trimmedString.split(/\s+/); // Using a regex to split words including spaces
        const lastWordWithPunctuation = wordsArray.pop(); // Retrieve the last word, including punctuation
      
        // Replace the last word in the original string with the last word and its punctuation wrapped in <strong> tags
        const stringWithStrongTag = trimmedString.replace(
          new RegExp(`(${lastWordWithPunctuation.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})$`),
          `<strong>$1</strong>`
        );
      
        return stringWithStrongTag;
      }
    //
    const myString = $('h1.heading-title').text();
    if($('body').is('.single, .category, .author, .search')){
        const stringWithLastWordInStrong = addStrongTagToLastWord(myString);
        $('h1.heading-title').html(stringWithLastWordInStrong);
    }
    //
    //$('.home .wp-block-columns').addClass('fadeup');
});